export class DirectPayIn {
    public payInId: string;

    public status: string;

    public result?: string;

    public resultCode?: string;

    public resultMessage?: string;

    public tag: string;
}
